import { PropsWithChildren, ReactElement, useContext } from 'react';
import { AccountHeader } from '@pb/shared/ui/organisms/account-header';
import { WebViewContext } from '@pb/shared/contexts/webview';
import { accountNavigationMenuItems } from '@pb/configuration';
import { getAppEnvironmentSettings } from '@pb/apps/offers/services/environment';
import { Stepper } from '@pb/apps/offers/components/molecules/stepper';
import { TLayoutProperties } from './layout.types';
import { StyledWrapper, StyledMain, StyledContent } from './layout.styled';

export function Layout({
    steps,
    children,
}: PropsWithChildren<TLayoutProperties>): ReactElement {
    const { baseUrl, apiBaseUrl } = getAppEnvironmentSettings();

    const isWebView: boolean = useContext(WebViewContext);

    return (
        <StyledWrapper data-testid="layout">
            {isWebView ? null : (
                <AccountHeader
                    navigationMenuItems={accountNavigationMenuItems}
                    baseUrl={baseUrl}
                    apiBaseUrl={apiBaseUrl}
                />
            )}
            {steps && <Stepper steps={steps} />}
            <StyledMain
                element="main"
                id="main"
                hasSteps={steps !== undefined && steps.length > 0}
            >
                <StyledContent>{children}</StyledContent>
            </StyledMain>
        </StyledWrapper>
    );
}
